import React, { useEffect } from 'react'
import { datadogRum } from '@datadog/browser-rum'
import { Button, ContentSection, Icon } from 'sidecar-components'

const NotFound = ({
  text = "Oops! This is not the page you're looking for.",
  subtext,
  backToPreviousPage = false,
  trackAs404 = false,
}) => {
  useEffect(() => {
    if (!trackAs404) return
    datadogRum.addAction('route_not_found', {
      url: window.location.pathname + window.location.search,
    })
  }, [trackAs404])

  return (
    <ContentSection testId="info_notFound">
      <Icon
        name="sidecar"
        className="mt-10 mx-auto color-iconBrand-default shrink-0"
        size="4xl"
      />
      <h1 data-testid="info_notFoundTitle" className="text-center">
        {text}
      </h1>
      {!!subtext && (
        <p data-testid="info_subText" className="text-center">
          {subtext}
        </p>
      )}

      <p className="text-center">
        {backToPreviousPage ? (
          <Button
            size="large"
            icon="forward"
            testId="link_goBack"
            onClick={() => window.history.back()}
          >
            Go back
          </Button>
        ) : (
          <Button
            size="large"
            icon="forward"
            testId="link_returnToSafety"
            path="/"
            pathType="internal"
          >
            Return to safety
          </Button>
        )}
      </p>
    </ContentSection>
  )
}

export default NotFound
